import css from 'styled-jsx/css';

const styles = css.global`@media (min-width: 992px) {
    #perguntas .perguntas-contain{
    margin-top: 112px;
    margin-bottom: 24px;
    }
}`;

export default styles;